import React from 'react';

import icon from 'assets/images/softwares/AcidGasInjection1.png';

const Icon = ({ width }) => <img src={icon} alt="Acid Gas Injection" width={width || '25'} />;

export default Icon;
